<template>
  <div class="col1">
    <div class="block-producto">
      <GarantiasDeUnProducto
        class="garantias"
        :producto="producto"
        :show="true"
      />
      <PrecioDeUnProducto :precios="producto.precios" />
    </div>
    <DetalleGarsDeUnProducto
      :producto="producto"
      :mostrarDetallesGarantias="false"
    />
  </div>
</template>

<script>
export default {
  store: ["step"],

  props: {
    producto: {
      type: Object
    }
  }
};
</script>

<style scoped>
.block-producto {
  background-color: white;
  padding: 1rem;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
}

.precio-container {
  display: flex;
  flex-flow: row wrap;
}
</style>
